import React from 'react';
import PropTypes from 'prop-types';
import { pathServer } from '../../../../util/Constant';
import PSBoletaRow, { BoletaRow } from '../../molecules/PSBoletaRow/PSBoletaRow';
import './index.scss';
import {capitalizeFirstLetter, capitalizeSentence, getMes} from '../../../../util/Util';

const PSFileBoleta = React.forwardRef(({ id, className, boleta }, ref) => {
  let currency, fullNameReceptor, documentReceptor, fullNameBeneficary, fullDirectionBeneficary, documentPolicy, fullNamePolicy,fullDirectionBeneficary2 , mounthDate, dateBoleta,fullDirectionPolicy,fullDirectionPolicy2, pensionType;
  let dataDiscount = [], dataIncrease = [];
  if (boleta) {
    fullNameBeneficary = `${boleta.beneficary.firstName + ' '}${boleta.beneficary.middleName + ' '}${boleta.beneficary.lastName + ' '}${boleta.beneficary.secondLastName}`;
    fullDirectionBeneficary = boleta.address.description;
    fullDirectionBeneficary2 = `${boleta.address.district.description + ' '}  ${boleta.address.province.description  + ' ' } ${boleta.address.region.description}`;

    documentPolicy = `${boleta.policy.titular.document.type === 1 ? 'DNI-' : ''}${boleta.policy.titular.document.number}`;
    fullNamePolicy = `${boleta.policy.titular.firstName  + ' '}${boleta.policy.titular.middleName  + ' '}${boleta.policy.titular.lastName  + ' ' }${boleta.policy.titular.secondLastName}`;
    fullDirectionPolicy = boleta.policy.titular.address.description;
    fullDirectionPolicy2 = boleta.policy.titular.address.district.description + ' ' + boleta.policy.titular.address.province.description + ' ' + boleta.policy.titular.address.region.description;
    fullNameReceptor = `${boleta.receiver.firstName + '  '}${boleta.receiver.middleName + ' '}${boleta.receiver.lastName  + '  '}${boleta.receiver.secondLastName}`;
    documentReceptor = boleta.receiver.document.number;

    mounthDate = getMes(boleta.period.substring(4, 6));
    dateBoleta = mounthDate + ' ' + boleta.period.substr(0, 4);

    dataIncrease = boleta.detail.filter((b) => b.type.category === 'H');
    dataDiscount = boleta.detail.filter((b) => b.type.category === 'D');

    pensionType= boleta.policy && boleta.pensionType ? boleta.pensionType.description.toLowerCase() :'Rentas Vitalicias';
  }
   currency = boleta ? (boleta.currency.shortDescription + ' ') : 'S/.';

    return (
    <div ref={ref} id={id} className={`app-file-boleta hidden-content-force ${className}`}>
      <div className="report-header">
        <div>
          <img src={`${pathServer.PATH_ICONS}logo_oficial.jpeg`} />
        </div>
        <div className="report-header-company">
          <h4>Boleta de Pago de Pensión</h4>
          <h3>{boleta ? dateBoleta : 'Mayo 2019'}</h3>
          <div className="report-header-ruc">
            <label>Compañia: Protecta S.A. Compañía de Seguros</label>
            <label>R.U.C.: 20517207331</label>
          </div>
        </div>
      </div>
      <div className="report-body">
        <div className="report-body-title">
          <div className="d-flex">
            <h3>Póliza </h3> <span> : </span> <h3> {boleta ? boleta.policy.number : '0000000322'}</h3>
          </div>
          <div className="d-flex text-capitalize">
            <h3>Tipo de pensión </h3> <span> : </span> <h3> {pensionType}</h3>
          </div>
          <div className="d-flex">
            <h3>Nro Beneficiario </h3> <span> : </span> <h3> {boleta ? boleta.order : '2'}</h3>
          </div>
        </div>
        <div className="report-body-content">
          <div className="report-description">
            <p> Nos comprometimos a pagarte una pensión durante toda la vida para que tu mayor preocupación sea disfrutarla.</p>
          </div>
          <div className="report-content-fields">

            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Ident. Afiliado" />
              <PSBoletaRow type={BoletaRow.white} className="row-small"  name={boleta? documentPolicy : "DNI - 07659710"}/>
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Nombre" />
              <PSBoletaRow type={BoletaRow.white} className="row-small"  name={boleta ? fullNamePolicy : "Carmen Rosa Meza Osorio De Osorio"}/>
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Dirección" />
              <PSBoletaRow type={BoletaRow.white} className="row-small"  name= {boleta? fullDirectionPolicy :  "Av. Las Begonias Mz K Lote 1 Coo. Pablo Patron"}/>
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.hidden} name="" />
              <PSBoletaRow type={BoletaRow.white}  className="row-small" name={boleta? fullDirectionBeneficary2 : "Lurigancho-chosica-lima-lima"} />
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Ident. Pensionista" />
              <PSBoletaRow type={BoletaRow.white} className="row-small"  name={boleta ?`${boleta.beneficary.document.type === 1 ? 'DNI' : '' }-${ boleta.beneficary.document.number}` : 'DNI-08363399'} />
            </div>

            <div className="row mt-2">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Nombre" />
              <PSBoletaRow type={BoletaRow.white} className="row-small" name= {boleta ? fullNameBeneficary : "Jose Luis Osorio Dominguez" }/>
            </div>

            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Dirección" />
              <PSBoletaRow type={BoletaRow.white} className="row-small"  name= {boleta? fullDirectionBeneficary :  "Av. Las Begonias Mz K Lote 1 Coo. Pablo Patron"}/>
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.hidden} name="" />
              <PSBoletaRow type={BoletaRow.white} className="row-small"  name={boleta? fullDirectionPolicy2 : "Lurigancho-chosica-lima-lima"} />
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Inst. de salud" />
              <PSBoletaRow type={BoletaRow.white} name= {boleta ? boleta.healthInsurance.description : "ESSALUD" }/>
            </div>
            <div className="row mt-2">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Ident. Receptor" />
              <PSBoletaRow type={BoletaRow.white}className="row-small"  name={`DNI - ${documentReceptor || '08363399'}`} />
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Receptor" />
              <PSBoletaRow type={BoletaRow.white} className="row-small"  name={fullNameReceptor || ''} />
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Vía de pago" />
              <PSBoletaRow type={BoletaRow.white} className="row-small"  name={boleta ? boleta.way.description : 'Transferencia AFP - Integra'} />
            </div>
            <div className="row">
              <PSBoletaRow type={BoletaRow.blue} isBold name="Vence tutor" />
              <PSBoletaRow type={BoletaRow.white} name="" />
            </div>

            <div className="row-2 mt-2">
              <PSBoletaRow className="title-ammount" type={BoletaRow.blue} isBold name="Ingresos" />
              <PSBoletaRow className="title-ammount" type={BoletaRow.blue} isBold name="Descuentos" />
            </div>
            <div className="row-2 mt-0">
              <div>
                {dataIncrease.map( increase => {
                  return <div className="row-2 mt-0">
                      <PSBoletaRow className="label-left" type={BoletaRow.gray1} isBold name={capitalizeSentence(increase.type.description)} />
                      <PSBoletaRow className="label-right" type={BoletaRow.gray2} name={`${currency}${increase.amount}`} />
                  </div>
                })}
                <div className="row-2">
                  <PSBoletaRow className="label-left" type={BoletaRow.orange} isBold name="Total ingresos" />
                  <PSBoletaRow className="label-right" type={BoletaRow.orange2} isBold  name={boleta ? `${currency}${  boleta.assetAmount}` :  "S/.100.72" } />
                </div>
              </div>
              <div>
                {dataDiscount.map( discount => {
                  return <div className="row-2 mt-0">
                    <PSBoletaRow className="label-left" type={BoletaRow.gray1} isBold name={capitalizeSentence(discount.type.description)} />
                      <PSBoletaRow className="label-right" type={BoletaRow.gray2} name={`${currency}${discount.amount}`} />
                  </div>
                })}
                <div className="row-2">
                  <PSBoletaRow className="label-left" type={BoletaRow.gray1} name="Total descuentos" />
                  <PSBoletaRow className="label-right" type={BoletaRow.gray2} name={boleta ? `${currency}${  boleta.discountAmount}` :  "S/.100.72" }/>
                </div>
                <div className="row-2">
                  <PSBoletaRow className="label-left" isBold type={BoletaRow.orange} name="Total pensión líquida" />
                  <PSBoletaRow className="label-right" isBold type={BoletaRow.orange2} name= {boleta ? `${currency} ${  boleta.liquidAmount}` : "S/ 2417.25"}/>
                </div>
              </div>
            </div>
          </div>
          <div className="report-footer">
            <h5 className="footer-description">
              Declaro que este importe lo he recibido a mi entera y completa satisfacción, por tanto, Protecta S.A. Compañía de Seguros, queda relevada de toda responsabilidad futura por la pensión del mes arriba mencionado.
            </h5>
            <div className="row">
              <PSBoletaRow
                isBold
                type={BoletaRow.blue}
                name={
                  boleta
                    ? `La suma de: ${boleta.liquidAmountDescription}`
                    : ' La suma de: DOS MIL CUATROCIENTOS DIECISIETE CON 25/100 NUEVOS SOLES'
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
);

PSFileBoleta.displayName = 'PSFileBoleta';

PSFileBoleta.defaultProps = {
  className: '',
  boleta: null,
};

PSFileBoleta.propTypes = {

  className: PropTypes.string,
  boleta: PropTypes.object

};

export default PSFileBoleta;
